/**
 * Shared Api errors that can be reported from any controller.
 */
export var SharedErrorCode;
(function (SharedErrorCode) {
    /**
     * The given pagination parameters are invalid.
     */
    SharedErrorCode["BadPaginationParams"] = "shared/BadPaginationParams";
    /**
     * Invalid API Key to regional api
     */
    SharedErrorCode["UndefinedCredentialError"] = "shared/UndefinedCredentialError";
})(SharedErrorCode || (SharedErrorCode = {}));
